var _circle, _circle2, _circle3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionExpiryReminder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.35,
    fill: "#FFE5CA",
    stroke: "#FFD9B0",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "rgba(255,255,255,0.82)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 23.33,
    fill: "#FFE5CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 28.002C19 29.782 19.5278 31.522 20.5168 33.0021C21.5057 34.4821 22.9113 35.6357 24.5558 36.3169C26.2004 36.9981 28.01 37.1763 29.7558 36.829C31.5016 36.4818 33.1053 35.6246 34.364 34.3659C35.6226 33.1072 36.4798 31.5036 36.8271 29.7578C37.1743 28.0119 36.9961 26.2023 36.3149 24.5578C35.6337 22.9133 34.4802 21.5077 33.0001 20.5187C31.5201 19.5298 29.78 19.002 28 19.002C25.484 19.0114 23.069 19.9932 21.26 21.742L19 24.002",
    stroke: "#FF9124",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.002V24.002H24",
    stroke: "#FF9124",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionExpiryReminder);
export default __webpack_public_path__ + "static/media/subscription-expiry-reminder.8e050729c186d8740937996d0af4a16c.svg";
export { ForwardRef as ReactComponent };